// extracted by mini-css-extract-plugin
module.exports = {"layout":"page-header_layout__7oJ_b","hero":"page-header_hero__ZaXWN","headline":"page-header_headline__5ZAhH","heroWrapper":"page-header_heroWrapper__v9_re"};